"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseOrganizationIntegrationSchema = exports.OrganizationIntegrationTypeSchema = exports.OrganizationIntegrationType = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
// Organization Integration Types
var OrganizationIntegrationType;
(function (OrganizationIntegrationType) {
    OrganizationIntegrationType["IntuitQuickBooks"] = "intuit_quickbooks";
    OrganizationIntegrationType["GoogleDrive"] = "google_drive";
})(OrganizationIntegrationType || (exports.OrganizationIntegrationType = OrganizationIntegrationType = {}));
// Create a Zod schema based on the TypeScript enum
exports.OrganizationIntegrationTypeSchema = zod_1.z.nativeEnum(OrganizationIntegrationType);
// Base Integration Schema not to be used directly
exports.BaseOrganizationIntegrationSchema = base_schema_1.BaseSchema.extend({
    name: zod_1.z.string().optional(),
    type: exports.OrganizationIntegrationTypeSchema,
    addedBy: zod_1.z.string(),
    updatedBy: zod_1.z.string().optional(),
    deletedBy: zod_1.z.string().optional(),
});
//# sourceMappingURL=base-organization-integration.js.map